import { collectionGroup, getDocs, query, where } from 'firebase/firestore';
import { uniq } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { db } from '../../firebase';
import { isNotNull } from '../../utils/isNotNull';

type Props = {
  phone: string | null;
  email: string | null;
};

const useMyCafes = ({ email, phone }: Props) => {
  const [cafeIds, setCafeIds] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  const fetchCafes = useCallback(async () => {
    if (email || phone) {
      setIsLoading(true);
      setIsError(false);

      try {
        const queryByPhone = query(collectionGroup(db, 'workers'), where('phone', '==', phone));
        const queryByEmail = query(collectionGroup(db, 'workers'), where('email', '==', email));
        const snapshotByPhone = await getDocs(queryByPhone);
        const snapshotByEmail = await getDocs(queryByEmail);
        const cafeIdsByPhone = snapshotByPhone.docs.map((doc) => doc.ref.parent.parent?.id).filter(isNotNull);
        const cafeIdsByEmail = snapshotByEmail.docs.map((doc) => doc.ref.parent.parent?.id).filter(isNotNull);

        setCafeIds(uniq([...cafeIdsByPhone, ...cafeIdsByEmail]));
      } catch (error) {
        setIsError(true);
      } finally {
        setIsLoading(false);
      }
    }
  }, [email, phone]);

  useEffect(() => {
    fetchCafes();
  }, [fetchCafes]);

  return { cafeIds, isLoading, isError, fetchCafes };
};

export default useMyCafes;
